module.exports = __webpack_public_path__ + "img/Si-plunger-Model.c3d5d54b.svg";